"use client";
import { Col, Row, Toast, ToastContainer } from "@/utils/bootstrap";
import SvgToastClose from "./SvgToastClose";
import React from "react";
interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  message: any;
  danger?: boolean;
  success?: boolean;
  top?: boolean;
  delay?: number;
  cancelIcon?: boolean;
  width?: React.CSSProperties["width"];
  paddingBottom?: React.CSSProperties["paddingBottom"];
  paddingTop?: React.CSSProperties["paddingTop"];
}
const AppToast: React.FC<Props> = ({
  show,
  setShow,
  message,
  danger,
  success,
  top,
  delay = 7000,
  cancelIcon = true,
  width,
  paddingBottom = 20,
  paddingTop = 80,
}) => {
  return (
    <ToastContainer
      position={top ? "top-center" : "bottom-center"}
      className="position-fixed"
      style={top ? { zIndex: 2000, paddingTop } : { zIndex: 2000, paddingBottom }}
    >
      <Toast
        show={show}
        onClose={() => setShow(false)}
        delay={delay}
        autohide
        className={`my-toast-container ${danger ? "danger" : success ? "success" : ""}`}
        style={{ width }}
      >
        <Row className="m-0 align-items-center" style={{ gap: 16 }}>
          <Col className="p-0">{message}</Col>
          {cancelIcon && (
            <Col className="p-0 col-auto">
              <SvgToastClose onClick={() => setShow(false)} />
            </Col>
          )}
        </Row>
      </Toast>
    </ToastContainer>
  );
};

export default AppToast;
